import React, { useState, useEffect, useCallback } from 'react'
import * as Yup from 'yup'
import moment from 'moment'
import { Formik, Form, Field } from 'formik'
import { useSelector, useDispatch } from 'react-redux'
import { useModal } from 'react-modal-hook'
import Modal from '../../components/Modal/Modal'
import InputError from '../../components/InputError/InputError'
import NeoButton from '../../components/NeoButton/NeoButton'
import NeoInput from '../../components/NeoInput/NeoInput'
import NeoOTP from '../../components/FormComponents/NeoOTP'
import NeoSuccess from '../../components/FormComponents/NeoSuccess'
import { useHistory, useLocation } from 'react-router-dom'
import NumberFormat from 'react-number-format'
import NeoLoader from '../../components/FormComponents/NeoLoader'
import AccountDisplay from '../../components/account-display/account-display'
import { getCurrentAccDetailsSelector } from '../../store/selectors/app.selector'
import PaymentsService from '../../services/payments.service'
import LayoutWithAccountCard from '../Layout/layout-account-card'
import { setIsAcctRefresh } from '../../store/actions/app.actions'
import TermsAndCondition from '../../components/TermsAndConditions/TermsAndCondition'
import NotificationService from '../../services/notification.service'
import {
  BUTTON_KEYS,
  VALIDATION_KEYS,
  PAYMENT_KEYS,
  SIDE_NAV_KEYS,
} from '../../utils/translation-constants'
import { useTranslation } from 'react-i18next'
import validationConfig from 'custom/config/validation.config.json'
import Loading from 'custom/assets/loaders/Loading'
const servicesConfig = validationConfig['payments']['services']
import clientAdditionalFields from 'custom/config/payments.additionalFields.json'
import QuickLinkService from '../../services/quick-link.service'
import { getRoleAccessKeySelector } from '../../selectors/app.selector'

export default function BillerProduct() {
  const location = useLocation()
  const [selectedBiller, setSelectedBiller] = useState({})
  const [productDetails, setProductDetails] = useState({ products: [] })
  const [selectedProduct, setSelectedProduct] = useState({
    amountLocalCur: '',
    amountType: '',
    name: '',
  })
  const history = useHistory()
  const dispatch = useDispatch()
  const [billers, setBillers] = useState([])
  const [quoteId, setQuoteId] = useState('')
  const [otp, setOTP] = useState('')
  const [stage, setStage] = useState(0)
  const [loading, setLoading] = useState(false)
  const [loading1, setLoading1] = useState(false)
  const [formValues, setFormValues] = useState(null)
  const [beneFormValues, setBeneFormValues] = useState({
    merchant: '',
    serviceNumber: '',
    shortName: '',
  })
  const srcAccountDetails = useSelector(getCurrentAccDetailsSelector)
  const [message, setMessage] = useState('Error Placeholder')
  const [randomKey, setRandomKey] = useState('')
  const [otpEnabled, setOtpEnabled] = useState(false)
  const [showBen, setShowBen] = useState(false)
  const [showBenList, setShowBenList] = useState([])
  const [zraAmount, setzraAmount] = useState(0)
  const [verifyDetails, setVerifyDetails] = useState({})
  const [error, setError] = useState({})
  const [requestValues, setRequestValues] = useState({})
  const { t } = useTranslation()
  const [billsList, setBillsList] = useState([])
  const [billerBeneList, setBillerBeneList] = useState([])
  const [additionalFieldValues, setAdditionalFieldValues] = useState({})
  const [additionalFieldValidations, setAdditionalFieldValidations] = useState({})
  const accessKey = useSelector(getRoleAccessKeySelector)
  const [successResponse, setSuccessResponse] = useState({})
  const [quoteDetails, setQuoteDetails] = useState({})

  const LABELS = {
    CASHIN: t(PAYMENT_KEYS.MOBILE_NO),
    DATA: t(PAYMENT_KEYS.MOBILE_NO),
    CASHOUT: t(PAYMENT_KEYS.MOBILE_NO),
    TOPUP: t(PAYMENT_KEYS.MOBILE_NO),
    SCHOOLPAY: t(PAYMENT_KEYS.STUDENT_NO),
    DTH: t(PAYMENT_KEYS.SUBSCRIBER_NO),
    WATER: t(PAYMENT_KEYS.SERVICE_NO),
    ELECTRICITY: t(PAYMENT_KEYS.BILL_NUMBER),
    INTERNET: t(PAYMENT_KEYS.ACCOUNT_NO),
    INSURANCE: t(PAYMENT_KEYS.INSURANCE_NO),
    TAX: t(PAYMENT_KEYS.SERVICE_NO),
    TRAVEL: t(PAYMENT_KEYS.MOBILE_NO),
    SUBSCRIPTION: t(PAYMENT_KEYS.CUSTOMER_NO),
  }

  const [showModal, hideModal] = useModal(
    () => (
      <Modal>
        <div className='modal-error-body'>
          <h6>{error?.message}</h6>
          <div className='modal-btn-style'>
            <NeoButton
              tabIndex='1'
              mode='newDesign'
              type='button'
              text={t(BUTTON_KEYS.OK)}
              onClick={() => {
                hideModal()
              }}
            />
          </div>
        </div>
      </Modal>
    ),
    [error],
  )

  useEffect(() => {
    if (location.state === undefined) {
      history.push('/payments')
      return
    }
    // console.log(location?.state?.billerDetails)
    setSelectedBiller(location?.state?.billerDetails)
    getProductDetails()
    fetchBillerBeneficiaries()
    // getBillerBen(location?.state?.billerDetails)
  }, [])

  const getProductDetails = useCallback(async () => {
    try {
      const { billerDetails } = location?.state
      setLoading(true)
      const response = await PaymentsService.getServiceById({
        fetchProducts: true,
        serviceId: billerDetails.serviceId,
      })
      if (response.status === 200) {
        setProductDetails(response.data)

        setLoading(false)
        response.data['fetchPendingBills'] ? setStage(5) : setStage(1)
        getAdditionalFields(response.data)
      }
    } catch (err) {
      setMessage(err)
    }
  }, [])

  const fetchPendingBills = useCallback(
    async (values, setTouched) => {
      try {
        if (values.serviceNumber === '') {
          setTouched({ serviceNumber: true })
          return false
        }
        setLoading1(true)
        const { billerDetails } = location?.state
        const response = await PaymentsService.getPendingBills({
          serviceNumber: values.serviceNumber,
          serviceId: billerDetails.serviceId,
          srcAccount: srcAccountDetails.accountNo,
          srcAccBranch: srcAccountDetails.brnCode,
          merchant: productDetails?.merchantId || productDetails?.description,
        })
        if (response.status === 200) {
          setLoading1(false)
          if (response.data['pendingBills']) {
            setBillsList(response.data['pendingBills'])
          }
        }
      } catch (err) {
        setMessage(err)
        setLoading1(false)
      }
    },
    [productDetails],
  )

  const fetchBillerBeneficiaries = useCallback(async () => {
    try {
      const response = await PaymentsService.getBillerBeneficiaries()
      if (response.status === 200) {
        setBillerBeneList(
          response.data['billerBeneficiary'].filter(
            (ele) => ele.serviceId === location?.state?.billerDetails?.serviceId,
          ),
        )
      }
    } catch (err) {}
  }, [])

  const setSelectedProductCallback = useCallback(
    (data) => {
      const selectedProductFull = productDetails.products.find(
        (value) => value.description === data,
      )
      setSelectedProduct(selectedProductFull)
    },
    [productDetails],
  )

  const handleSelectedBillCallback = useCallback(
    (data) => {
      const selectedProductFull = billsList.find((value) => value.billNumber === data)
      setSelectedProduct(selectedProductFull)
      setBillerBeneList([])
    },
    [billsList],
  )

  const onVerify = useCallback(
    async (data, { setSubmitting }) => {
      try {
        setLoading(true)
        setSubmitting(true)
        setFormValues(data)
        if (data?.floatAmount === 0) {
          return
        }
        const reqParams = {
          amount: data.debitAmount,
          srcAccBranch: srcAccountDetails.brnCode,
          merchant: productDetails?.merchantId || productDetails?.description,
          productId: selectedProduct?.productId || '',
          schoolName: selectedBiller.category === 'SCHOOLPAY' ? selectedProduct?.description : '',
          serviceId: productDetails.serviceId,
          serviceNumber: data.serviceNumber,
          studentClass: data.studentClass,
          srcAccount: srcAccountDetails.accountNo,
          srcCurrency: srcAccountDetails.currency,
          isFixed: selectedProduct?.amountType == 'FIXED' ? true : false,
          voucherType: selectedProduct.name || '',
          customerName: '',
          isScheduled: 'N',
          scheduledDate: '',
          remarks: data.remarks || '',
        }
        const response = await PaymentsService.getBillQuote(reqParams)
        if (response.status === 200) {
          setSubmitting(false)
          setLoading(false)
          setOtpEnabled(response.data['otpEnable'])
          setQuoteDetails(response.data['quote'])
          setVerifyDetails(response.data)
          setRequestValues(reqParams)
          setStage(2)
        }
      } catch (err) {
        setSubmitting(false)
        setLoading(false)
      }
    },
    [selectedProduct, selectedBiller, srcAccountDetails, productDetails],
  )

  const confirmPayment = useCallback(async () => {
    setLoading(true)
    try {
      const additionalValues = {}

      if (
        Object.keys(clientAdditionalFields).length > 0 &&
        clientAdditionalFields[productDetails?.category]
      ) {
        clientAdditionalFields[productDetails?.category].forEach((item) => {
          additionalValues[item.fieldName] = formValues[item.fieldName]
        })
      }
      const formattedAmount = parseFloat(quoteDetails['amount']).toFixed(2)

      const response = await PaymentsService.billPaymentInitiate({
        ...requestValues,
        amount: formattedAmount,
        quoteId: verifyDetails['quote']['quoteId'],
        otp: otp,
        randomKey: verifyDetails['randomKey'],
        cdf: {
          ...additionalValues,
        },
      })
      if (response.status === 200) {
        dispatch(setIsAcctRefresh(true))
        setSuccessResponse(response.data)
        setMessage(response.data['message'])
        setStage(4)
        setLoading(false)
      }
    } catch (err) {
      setLoading(false)
      setOTP('')
    }
    setLoading(false)
  }, [
    selectedBiller,
    selectedProduct,
    otp,
    srcAccountDetails,
    verifyDetails,
    requestValues,
    quoteDetails,
  ])

  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderPaymentFormWithoutBills()
      case 2:
        return renderConfirmation()
      case 3:
        return <NeoOTP otp={otp} setOTP={setOTP} onSubmit={confirmPayment} loading={loading} />
      case 4:
        return (
          <NeoSuccess
            onClick1={async () =>
              await QuickLinkService.pdfReceipt({
                transRefNum: successResponse.referenceNo,
                refId: '',
                module: 'BILLPAYMENT',
              })
            }
            module='DOWNLOAD_RECEIPT'
            roleKey={accessKey}
            message={message}
            linkPath='/payments'
          />
        )
      case 5:
        return renderPaymentFormWithBills()
      default:
        return renderLoading()
    }
  }

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  const getAdditionalFields = useCallback((productDetails) => {
    try {
      if (
        Object.keys(clientAdditionalFields).length > 0 &&
        clientAdditionalFields[productDetails?.category]
      ) {
        const initialValues = {}
        const validations = {}
        clientAdditionalFields[productDetails?.category].forEach((item) => {
          initialValues[item.fieldName] = ''
          validations[item.fieldName] = item.mandatory
            ? Yup.string().required(`${t(item.fieldLabel)} ${t(PAYMENT_KEYS.IS_REQUIRED)}`)
            : Yup.string().optional()
        })
        setAdditionalFieldValidations(validations)
        setAdditionalFieldValues(initialValues)
        // const yepSchema = clientAdditionalFields[productDetails?.category].reduce(createYupSchema, {})
      }
    } catch (err) {}
  }, [])

  const ProductPaymentFormSchema = Yup.object().shape({
    serviceNumber: Yup.string().required(
      `${LABELS[productDetails?.category] || t(PAYMENT_KEYS.SERVICE_NO)} ${t(
        PAYMENT_KEYS.IS_REQUIRED,
      )}`,
    ),
    studentClass:
      selectedBiller.category === 'SCHOOLPAY'
        ? Yup.string().required(t(VALIDATION_KEYS.STUDENT_CLASS))
        : Yup.string().optional(),

    amount: Yup.string().required(t(VALIDATION_KEYS.AMOUNT)),
    remarks: Yup.string().required(t(VALIDATION_KEYS.REMARK)),
    product:
      !productDetails.fetchPendingBills && productDetails.products.length > 0
        ? Yup.string().required(t(VALIDATION_KEYS.PRODUCT))
        : Yup.string().optional(),
    customRemarks: Yup.string().when('remarks', {
      is: 'Custom',
      then: Yup.string().required(t(VALIDATION_KEYS.CUSTOM_REMARKS)),
      otherwise: Yup.string().optional(),
    }),
    billNo:
      billsList.length > 0
        ? Yup.string().required(t(VALIDATION_KEYS.BILL_NO))
        : Yup.string().optional(),
    ...additionalFieldValidations,
  })

  // const ProductPaymentFormSchema = Yup.object().shape({
  //   serviceNumber: Yup.string().required('required'),
  //   amount: Yup.string().required(t(VALIDATION_KEYS.AMOUNT_REQUIRED)),
  //   remarks: Yup.string().required(t(VALIDATION_KEYS.REMARKS_REQUIRED)),
  //   product: Yup.string().required(t(VALIDATION_KEYS.PRODUCT_REQUIRED)),
  // })

  function renderAdditionalFieldsForSpecificClient(
    errors,
    touched,
    handleChange,
    values,
    setFieldValue,
  ) {
    return (
      <>
        {Object.keys(clientAdditionalFields).length > 0 &&
          clientAdditionalFields[productDetails?.category] && (
            <>
              {clientAdditionalFields[productDetails?.category].map((field, index) => (
                <div className='form-group col-12' key={index}>
                  {/* {field.type === 'onlyNumber' && ( */}
                  <NeoInput
                    tabIndex={`${index + 1}`}
                    showAsterisk={field.mandatory}
                    text={t(field.fieldLabel)}
                    onChange={(value) => {
                      setFieldValue(field?.fieldName, value?.value || value?.target?.value)
                    }}
                    mode={field.type}
                    name={field.fieldName}
                  />
                  {/* )} */}
                  <InputError text={errors[field?.fieldName]} touched={touched[field?.fieldName]} />
                </div>
              ))}
            </>
          )}
      </>
    )
  }

  function renderPaymentFormWithBills() {
    return (
      <div className=''>
        <AccountDisplay currentAccountDetail={srcAccountDetails} />
        <Formik
          enableReinitialize
          initialValues={{
            serviceNumber: selectedProduct ? selectedProduct?.serviceNumber || '' : '',
            studentClass: selectedProduct ? selectedProduct?.studentClass || '' : '',
            amount: selectedProduct ? selectedProduct?.amount || '' : '',
            floatAmount: selectedProduct ? selectedProduct?.amount || undefined : undefined,
            billNo: selectedProduct ? selectedProduct?.billNumber || '' : '',
            remarks: '',
            serviceNumberBen: '',
            showBen: false,
            customRemarks: '',
            ...additionalFieldValues,
          }}
          validationSchema={ProductPaymentFormSchema}
          onSubmit={onVerify}>
          {({ isSubmitting, errors, touched, handleChange, values, setFieldValue, setTouched }) => (
            <Form>
              <div>
                <div className='row'>
                  <div className='form-group col-8'>
                    {renderBillerBeneDetails(errors, touched, handleChange, values, setFieldValue)}
                  </div>

                  <div style={{ marginTop: 30 }} className='form-group col-4'>
                    {loading1 && <NeoLoader />}
                    {!loading1 && (
                      <NeoButton
                        tabIndex='3'
                        type='button'
                        mode='newDesign'
                        disabled={isSubmitting}
                        text={t(BUTTON_KEYS.SUBMIT)}
                        onClick={() => fetchPendingBills(values, setTouched)}
                      />
                    )}
                  </div>
                </div>

                {billsList.length > 0 && (
                  <>
                    <div className='form-group'>
                      <NeoInput
                        tabIndex='4'
                        text={t(PAYMENT_KEYS.BILL_NO)}
                        mode='select'
                        name='billNo'
                        showAsterisk={true}
                        onChange={(e) => {
                          handleSelectedBillCallback(e.target.value)
                        }}
                        list={billsList}
                        keyValue='billNumber'
                      />
                      <InputError text={errors.billNo} touched={touched.billNo} />
                    </div>
                    {renderAdditionalFieldsForSpecificClient(
                      errors,
                      touched,
                      handleChange,
                      values,
                      setFieldValue,
                    )}

                    <div className='form-group'>
                      <NeoInput
                        tabIndex='6'
                        text={t(PAYMENT_KEYS.AMOUNT)}
                        name='amount'
                        showAsterisk={true}
                        onChange={(values) => {
                          setFieldValue('floatAmount', values.floatValue)
                          setFieldValue('debitAmount', values.value)
                        }}
                        mode='amount'
                        value={values.amount}
                        disabled={selectedProduct.amountType === 'FIXED'}
                      />
                      <InputError text={errors.amount} touched={touched.amount} />
                      {values.floatAmount != undefined && values.floatAmount === 0 && (
                        <InputError
                          text={t(VALIDATION_KEYS.TRANSFER_AMOUNT_VALIDATION)}
                          touched={touched.amount}
                        />
                      )}
                    </div>

                    <div className='form-group'>
                      <NeoInput
                        tabIndex='7'
                        text={t(PAYMENT_KEYS.REMARKS)}
                        onChange={handleChange}
                        name='remarks'
                        showAsterisk={true}
                      />
                      <InputError text={errors.remarks} touched={touched.remarks} />
                    </div>

                    <div className='form-group'>
                      {values.remarks === 'Custom' && (
                        <div>
                          <NeoInput
                            tabIndex='8'
                            text={t(PAYMENT_KEYS.CUSTOM_REMARKS)}
                            onChange={handleChange}
                            name='customRemarks'
                            showAsterisk={true}
                          />
                          <InputError text={errors.customRemarks} touched={touched.customRemarks} />
                        </div>
                      )}
                    </div>

                    <div className='mt-3 form-group '>
                      {isSubmitting ? (
                        <NeoLoader />
                      ) : (
                        <NeoButton
                          tabIndex='9'
                          type='submit'
                          mode='newDesign'
                          disabled={isSubmitting}
                          text={t(BUTTON_KEYS.SUBMIT)}
                        />
                      )}
                    </div>
                  </>
                )}

                <div className='back-cancel-btn-container'>
                  <button
                    tabIndex={'10'}
                    className='back-cancel-btn btn btn-sm new-design-warning-text-color'
                    onClick={() => history.goBack()}>
                    {t(BUTTON_KEYS.CANCEL)}
                  </button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    )
  }

  function renderBillerBeneDetails(errors, touched, handleChange, values, setFieldValue) {
    return (
      <>
        {billerBeneList.length > 0 && (
          <div className='form-check biller-bene-checkbox'>
            <Field
              tabIndex={'1'}
              as='input'
              type='checkbox'
              className='form-check-input'
              id='check1'
              name='showBen'
              checked={values.showBen}
              onChange={() => {
                setFieldValue('showBen', !values.showBen)
                setFieldValue('serviceNumber', '')
                setFieldValue('studentClass', '')
                // setBillsList([])
                // setFieldValue('billNo','')
              }}
            />
            <label htmlFor='check1' className='form-check-label'>
              {t(PAYMENT_KEYS.BENEFICIARY)}
            </label>
          </div>
        )}
        {!values.showBen && (
          <>
            <div>
              <NeoInput
                tabIndex='2'
                text={LABELS[productDetails?.category] || t(PAYMENT_KEYS.SERVICE_NO)}
                onChange={handleChange}
                name='serviceNumber'
                showAsterisk={true}
                value={values.serviceNumber}
              />
              <InputError text={errors.serviceNumber} touched={touched.serviceNumber} />
            </div>
          </>
        )}
        {!values.showBen && selectedBiller.category === 'SCHOOLPAY' && (
          <>
            <div className='mt-2'>
              <NeoInput
                tabIndex='3'
                text={t(PAYMENT_KEYS.STUDENT_CLASS_NAME)}
                onChange={handleChange}
                name='studentClass'
                showAsterisk={true}
                value={values.studentClass}
              />
              <InputError text={errors.studentClass} touched={touched.studentClass} />
            </div>
          </>
        )}

        {values.showBen && (
          <>
            <NeoInput
              tabIndex='2'
              text={LABELS[productDetails?.category] || t(PAYMENT_KEYS.SERVICE_NO)}
              showAsterisk={true}
              mode='select'
              name='serviceNumber'
              onChange={handleChange}
              list={billerBeneList}
              keyValue='shortName'
              value={values.serviceNumber}
            />
            <InputError text={errors.serviceNumber} touched={touched.serviceNumber} />
          </>
        )}
      </>
    )
  }

  function renderPaymentFormWithoutBills() {
    return (
      <div className=''>
        <AccountDisplay currentAccountDetail={srcAccountDetails} />
        <Formik
          enableReinitialize
          initialValues={{
            serviceNumber: '',
            studentClass: '',
            amount: selectedProduct ? selectedProduct?.productAmount || '' : '',
            floatAmount: selectedProduct ? selectedProduct?.productAmount || undefined : undefined,
            product: selectedProduct ? selectedProduct?.description || '' : '',
            remarks: '',
            serviceNumberBen: '',
            showBen: false,
            customRemarks: '',
            mobileNo: '',
            ...additionalFieldValues,
          }}
          validationSchema={ProductPaymentFormSchema}
          onSubmit={onVerify}>
          {({ isSubmitting, errors, touched, handleChange, values, setFieldValue }) => (
            <Form>
              <div>
                {productDetails.products.length > 0 && (
                  <div className='row'>
                    <div className='form-group col-12'>
                      <NeoInput
                        tabIndex='1'
                        text={selectedBiller?.category || t(PAYMENT_KEYS.PRODUCT)}
                        showAsterisk={true}
                        mode='search-select'
                        name='product'
                        onChange={(e) => {
                          setSelectedProductCallback(e.target.value)
                          handleChange(e)
                          setFieldValue('amount', '')
                        }}
                        list={productDetails.products}
                        keyValue='description'
                      />
                      <InputError text={errors.product} touched={touched.product} />
                    </div>
                  </div>
                )}

                <div className='row'>
                  <div className='form-group col-12'>
                    {renderBillerBeneDetails(errors, touched, handleChange, values, setFieldValue)}
                  </div>

                  {renderAdditionalFieldsForSpecificClient(
                    errors,
                    touched,
                    handleChange,
                    values,
                    setFieldValue,
                  )}

                  <div className='form-group col-12'>
                    <NeoInput
                      tabIndex='4'
                      text={t(PAYMENT_KEYS.AMOUNT)}
                      name='amount'
                      onChange={(values) => {
                        setFieldValue('floatAmount', values.floatValue)
                        setFieldValue('debitAmount', values.value)
                      }}
                      mode='amount'
                      showAsterisk={true}
                      value={values.amount}
                      disabled={selectedProduct.amountType === 'FIXED'}
                    />
                    <InputError text={errors.amount} touched={touched.amount} />
                    {values.floatAmount != undefined && values.floatAmount === 0 && (
                      <InputError
                        text={t(VALIDATION_KEYS.TRANSFER_AMOUNT_VALIDATION)}
                        touched={touched.amount}
                      />
                    )}
                  </div>
                </div>

                <div className='row'>
                  <div className='form-group col-12'>
                    <NeoInput
                      tabIndex='5'
                      text={t(PAYMENT_KEYS.REMARKS)}
                      onChange={handleChange}
                      name='remarks'
                      showAsterisk={true}
                    />
                    <InputError text={errors.remarks} touched={touched.remarks} />
                  </div>
                </div>
                <div className='row'>
                  <div className='form-group col-12'>
                    {values.remarks === 'Custom' && (
                      <>
                        <NeoInput
                          tabIndex='6'
                          text={t(PAYMENT_KEYS.CUSTOM_REMARK)}
                          onChange={handleChange}
                          showAsterisk={true}
                          name='customRemarks'
                        />
                        <InputError text={errors.customRemarks} touched={touched.customRemarks} />
                      </>
                    )}
                  </div>
                </div>
                <div className='row'>
                  <div className='form-group col-12'>
                    {isSubmitting ? (
                      <NeoLoader />
                    ) : (
                      <NeoButton
                        tabIndex='7'
                        type='submit'
                        mode='newDesign'
                        disabled={isSubmitting}
                        text={t(BUTTON_KEYS.SUBMIT)}
                      />
                    )}
                  </div>
                </div>
                <div className='back-cancel-btn-container'>
                  <button
                    tabIndex={'8'}
                    className='back-cancel-btn btn btn-sm new-design-warning-text-color'
                    onClick={() => history.goBack()}>
                    {t(BUTTON_KEYS.CANCEL)}
                  </button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    )
  }

  function renderConfirmation() {
    return (
      <div>
        <div className='d-flex flex-column confirmation'>
          <AccountDisplay currentAccountDetail={srcAccountDetails} />
          <div>
            <h6 className='label'>
              {LABELS[productDetails?.category] || t(PAYMENT_KEYS.SERVICE_NO)}
            </h6>
            <h6 className='value'>{formValues?.serviceNumber}</h6>
          </div>
          {selectedBiller.category === 'SCHOOLPAY' && (
            <div>
              <h6 className='label'>{t(PAYMENT_KEYS.STUDENT_CLASS_NAME)}</h6>
              <h6 className='value'>{formValues?.studentClass}</h6>
            </div>
          )}

          <div>
            {verifyDetails?.quote.customerName && verifyDetails?.quote.customerName.trim() && (
              <div>
                <h6 className='label'>{t(PAYMENT_KEYS.PAYMENT_CUSTOMER_NAME)}</h6>
                <h6 className='value'>{verifyDetails?.quote.customerName}</h6>
              </div>
            )}
          </div>

          {productDetails?.fetchPendingBills && (
            <>
              <div>
                <h6 className='label'>{t(PAYMENT_KEYS.BILL_NO)}</h6>
                <h6 className='value'>{selectedProduct?.billNumber}</h6>
              </div>
              <div>
                <h6 className='label'>{t(PAYMENT_KEYS.BILL_DATE)}</h6>
                <h6 className='value'>{moment(selectedProduct?.billDate).format('DD-MM-YYYY')}</h6>
              </div>
              <div>
                <h6 className='label'>{t(PAYMENT_KEYS.BILL_DUE_DATE)}</h6>
                <h6 className='value'>
                  {moment(selectedProduct?.billDueDate).format('DD-MM-YYYY')}
                </h6>
              </div>
            </>
          )}

          {Object.keys(clientAdditionalFields).length > 0 &&
            clientAdditionalFields[productDetails?.category] && (
              <>
                {clientAdditionalFields[productDetails?.category].map((field, index) => (
                  <>
                    {formValues[field?.fieldName] !== '' && (
                      <div key={index}>
                        <h6 className='label'>{t(field?.fieldLabel)}</h6>
                        <h6 className='value'>{formValues[field?.fieldName]}</h6>
                      </div>
                    )}
                  </>
                ))}
              </>
            )}

          <div>
            <h6 className='label'>{t(PAYMENT_KEYS.AMOUNT)}</h6>
            <h6 className='value'>
              {quoteDetails['amount'] ? (
                <NumberFormat
                  value={quoteDetails['amount']}
                  displayType={'text'}
                  thousandSeparator={true}
                  prefix={''}
                  fixedDecimalScale={true}
                  decimalScale={2}
                  allowEmptyFormatting
                />
              ) : (
                <NumberFormat
                  value={formValues?.debitAmount}
                  displayType={'text'}
                  thousandSeparator={true}
                  prefix={''}
                  fixedDecimalScale={true}
                  decimalScale={2}
                  allowEmptyFormatting
                />
              )}
              {/* <NumberFormat
                value={formValues?.debitAmount}
                displayType={'text'}
                thousandSeparator={true}
                prefix={''}
                fixedDecimalScale={true}
                decimalScale={2}
                allowEmptyFormatting
              /> */}
            </h6>
          </div>
          <div>
            <h6 className='label'>{t(PAYMENT_KEYS.REMARKS)}</h6>
            <h6 className='value'>
              {formValues?.remarks === 'Custom' ? formValues?.customRemarks : formValues?.remarks}
            </h6>
          </div>

          <div>
            <TermsAndCondition module='BILLPAYMENT' />
          </div>
          <div className='mt-3 form-group col-12'>
            {loading ? (
              <NeoLoader />
            ) : (
              <NeoButton
                type='button'
                text={t(BUTTON_KEYS.CONFIRM)}
                mode='newDesign'
                onClick={async () => {
                  otpEnabled ? setStage(3) : await confirmPayment()
                }}
              />
            )}
          </div>
          <div className='back-cancel-style' onClick={() => setStage(1)}>
            {t(BUTTON_KEYS.BACK)}
          </div>
        </div>
      </div>
    )
  }

  return (
    <LayoutWithAccountCard
      pageTitle={`${selectedBiller?.category}- ${selectedBiller?.description}`}
      breadCumKey='BILLER_SERVICE_FORM'>
      <div className='new-design-form-style'>
        <div className='heading-style'>
          {selectedBiller?.category}- {selectedBiller?.description}
        </div>
        {renderSwitch()}
      </div>
    </LayoutWithAccountCard>
  )
}
